import { httpClient} from "./http-client";
import { httpClientPAdmin } from "./http-client-pAdmin";

const getMessageFromResponseData = (data) => {
  if (data == null) return null;
  if (typeof data === "string") return data;
  if (typeof data !== "object") return null;
  if (typeof data.message === "string" && data.message.trim()) return data.message;
  const nested = data.error;
  if (typeof nested === "string" && nested.trim()) return nested;
  if (nested && typeof nested === "object") {
    if (typeof nested.message === "string" && nested.message.trim()) return nested.message;
    if (typeof nested.code === "string" && nested.code.trim()) return nested.code;
  }
  return null;
};

const getErrorCodeFromResponseData = (data) => {
  if (data && typeof data === "object" && data.error && typeof data.error === "object") {
    return data.error.code;
  }
  return undefined;
};

const getRequest = async (url_path, params) => {
  try {
    const config = params && Object.keys(params).length > 0 ? { params } : {};
    const reponseData = await httpClient.get(url_path, config);
    return processResponse(reponseData);
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      error: error?.response?.data?.message ?? error?.message,
    };
  }
};
const getRequestPAdmin = async (url_path, params) => {
  try {
    const config = params && Object.keys(params).length > 0 ? { params } : {};
    const reponseData = await httpClientPAdmin.get(url_path, config);
    return processResponse(reponseData);
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      error: error?.response?.data?.message ?? error?.message,
    };
  }
};

const postRequestPAdmin = async (url_path, data) => {
  try {
    const reponseData = await httpClientPAdmin.post(url_path, data);
    return processResponse(reponseData);
  } catch (error) {
    const resData = error?.response?.data;
    const extracted = getMessageFromResponseData(resData);
    return {
      status: error?.response?.status ?? 500,
      error: extracted ?? error?.message ?? "Please try again after some time",
      errorCode: getErrorCodeFromResponseData(resData),
    };
  }
};

const putRequestPAdmin = async (url_path, data) => {
  try {
    const reponseData = await httpClientPAdmin.put(url_path, data);
    return processResponse(reponseData);
  } catch (error) {
    const resData = error?.response?.data;
    const extracted = getMessageFromResponseData(resData);
    return {
      status: error?.response?.status ?? 500,
      error: extracted ?? error?.message ?? "Please try again after some time",
      errorCode: getErrorCodeFromResponseData(resData),
    };
  }
};

const patchRequestPAdmin = async (url_path, data) => {
  try {
    const reponseData = await httpClientPAdmin.patch(url_path, data);
    return processResponse(reponseData);
  } catch (error) {
    const resData = error?.response?.data;
    const extracted = getMessageFromResponseData(resData);
    return {
      status: error?.response?.status ?? 500,
      error: extracted ?? error?.message ?? "Please try again after some time",
      errorCode: getErrorCodeFromResponseData(resData),
    };
  }
};
const getAllRequests = async (url_paths) => {
  try {
    const requests = url_paths.map((url) => httpClient.get(url));
    const responses = await Promise.allSettled(requests);

    const processedResponse = responses.map((responseData) => {
      if (responseData.status === "fulfilled") {
        return processResponse(responseData.value);
      } else {
        return processResponse(responseData.reason?.response);
      }
    });
    return processedResponse;
  } catch (error) {
    return [
      {
        status: error?.response?.status ?? 500,
        error: error?.response?.data?.message ?? error?.message,
      },
    ];
  }
};
const postRequest = async (url_path, data) => {
  try {
    const reponseData = await httpClient.post(url_path, data);

    return processResponse(reponseData);
  } catch (error) {
    const resData = error?.response?.data;
    const extracted = getMessageFromResponseData(resData);
    return {
      status: error?.response?.status ?? 500,
      error: extracted ?? error?.message ?? "Please try again after some time",
      errorCode: getErrorCodeFromResponseData(resData),
    };
  }
};

const deleteRequest = async (url_path, data) => {
  try {
    const reponseData = await httpClient.delete(url_path, { data: data });

    return processResponse(reponseData);
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      error: error?.response?.data?.message ?? error?.message,
    };
  }
};
const putRequest = async (url_path, data) => {
  try {
    const reponseData = await httpClient.put(url_path, data);
    return processResponse(reponseData);
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      error:
        error?.response?.data?.message ??
        error?.response?.data.error ??
        error.message,
    };
  }
};

const patchRequest = async (url_path, data) => {
  try {
    const reponseData = await httpClient.patch(url_path, data);
    return processResponse(reponseData);
  } catch (error) {
    const resData = error?.response?.data;
    const extracted = getMessageFromResponseData(resData);
    return {
      status: error?.response?.status ?? 500,
      error: extracted ?? error?.message ?? "Please try again after some time",
      errorCode: getErrorCodeFromResponseData(resData),
    };
  }
};

const processResponse = (reponseData) => {
  let response = {};
  try {
    if (
      reponseData.status === 200 ||
      reponseData.status === 201 ||
      reponseData.status === 204 ||
      reponseData.status === 207
    ) {
      response = {
        data: reponseData.data,
        status: reponseData.status,
      };
    } else {
      response = {
        status: reponseData.status,
        error: reponseData.error ?? reponseData?.data?.results?.[0]?.error ?? "Please try again after some time",
      };
    }
  } catch (error) {
    response = {
      status: error?.response?.status ?? 500,
      error: error?.response?.data?.message ?? error?.message,
    };
  }
  return response;
};

const uploadImage = async (formData, url_path) => {
  try {
    const response = await httpClient.post(url_path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return processResponse(response);
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      error: error?.response?.data?.message ?? error?.message,
    };
  }
};
const updateImage = async (formData, url_path) => {
  try {
    const response = await httpClient.put(url_path, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return processResponse(response);
  } catch (error) {
    return {
      status: error?.response?.status ?? 500,
      error: error?.response?.data?.message ?? error?.message,
    };
  }
};
export {
  getRequest,
  postRequest,
  putRequest,
  getAllRequests,
  uploadImage,
  updateImage,
  deleteRequest,
  patchRequest,
  getRequestPAdmin,
  postRequestPAdmin,
  putRequestPAdmin,
  patchRequestPAdmin,
};
